import React, { Component } from 'react'
import { Button, Col, Label, Row, Input, Form, Alert  } from 'reactstrap';
import FormInputSimples from '../../comum/components/FormInputSimples';
import SelectFiltro from '../../comum/components/SelectFiltro';
import lscache from 'lscache';
import { observer } from 'mobx-react';
import { IconeInformacao } from '../../comum/components/Icones';

@observer
export default class FiltrosAcompMobile extends Component {

    constructor(props) {
        super(props)

        this.controller = this.props.controller
    }

    componentDidMount () {    
        const botaoVoltar = lscache.get('acompProcesso-pesquisa-voltar'); 
        if (botaoVoltar)  {
            lscache.remove('acompProcesso-pesquisa-voltar');
            this.controller.documento = lscache.get('acompProcesso-doc');
            lscache.get('acompProcesso-navio') ? this.controller.navioSelecionado = lscache.get('acompProcesso-navio') : 
                                                 this.controller.navioSelecionado = {};
            lscache.get('acompProcesso-navio') ? this.controller.solicitaNavio = true : this.controller.solicitaNavio = false;
            this.controller.filtrar();
        }
        else {
            lscache.remove('acompProcesso-pesquisa-doc');
            lscache.remove('acompProcesso-doc');
            lscache.remove('acompProcesso-navio');            
        }  
    }

    filtrar = (e) => {
        e.preventDefault();
        this.controller.filtrar();
    }

    handleBlur = (event, e) => {
      this.controller.filtrar();
    }
    
    render() {
        return (
            <div>
                <Form>
                    <Row className="align-items-center">
                        <FormInputSimples xs={12} sm={9} md={9} lg={9}
                            titulo="BL house / CE / DI / CTe / Booking Exp"
                            value={lscache.get('acompProcesso-pesquisa-voltar') ? lscache.get('acompProcesso-doc') : ""}
                            onChange={(event) => this.controller.setBlHouse(event.target.value)} 
                        />
                        {this.controller.solicitaNavio &&
                            <SelectFiltro className="mb-1"
                                            titulo="Navio" sm={12} xs={12}
                                            itens={this.controller.naviosCE}
                                            valor={this.controller.navioSelecionado}
                                            naoLimpar={true}
                                            itensValor="Ce" itensLabel="Navio"
                                            onChange={this.controller.setNavio} 
                            />
                        }
                        <Col xs={12} sm={3} md={2} lg={2}>
                            <Button
                                className="mx-0 btn-com-bordas-primary btn-filtrar w-100"
                                onClick={() => { lscache.remove('acompProcesso-pesquisa-doc'); this.controller.filtrar()}}
                            >
                                Filtrar
                            </Button>
                        </Col>
                    </Row>
                    <Col xs={12} sm={12}>
                        <Row className="align-items-center">
                            <IconeInformacao style={{width:"36px"}} className="mr-1" />
                            <label style={{maxWidth: "85%", marginBottom:"0"}}>Informe o número do seu documento (importação, exportação ou cabotagem) e acompanhe o andamento de todo seu processo.</label>
                        </Row>
                    </Col>
                </Form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/FiltrosAcompMobile.js